import Intercom from '@intercom/messenger-js-sdk';
import { UserServerResponse } from 'src/core/types/user';

const app_id = import.meta.env.VITE_INTERCOM_APP_ID;
const isDevelopment =
  (import.meta.env.VITE_ENV && import.meta.env.VITE_ENV === 'dev') || false;

export const initializeIntercom = (user: UserServerResponse) => {
  if (!isDevelopment) return;
  if (!user) return;

  const { id, first_name, last_name, email, customer } = user;
  const user_id = id.toString();
  const name = `${first_name} ${last_name}`;
  const created_at = customer?.created_at
    ? Math.floor(new Date(customer.created_at).getTime() / 1000)
    : Math.floor(Date.now() / 1000);

  Intercom({
    app_id,
    user_id,
    name,
    email,
    created_at,
  });
};

export const shutdownIntercom = () => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
};

export const isIntercomActive = () => {
  return typeof window.Intercom === 'function';
};
